module.exports = __webpack_public_path__ + "img/bg-svip-right.366ce966.png";